<template>
  <!-- <div>
    {{ formattedActualValue }}
  </div> -->
  <div class="flex justify-between">
    <div class="flex flex-col">
      <span class="mb-1">{{ formattedActualValue }}</span>
    </div>
    <div class="flex flex-col text-right compared">
      <span v-if="displayCompare" class="flex -mr-1">
          <span class="mr-1">{{ formattedComparedValue }}</span>
          <feather-icon :icon="comparedValue < 0 ? 'ArrowDownIcon' : 'ArrowUpIcon'" :svgClasses="[comparedValue < 0 ? 'text-danger' : 'text-success'  ,'stroke-current h-4 w-4 mb-1 mr-1']"></feather-icon>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EntryDiffValueCellRenderer',
  data() {
    return {
      actualValue: null,
      previousValue: null,
      isTonnage : false,
      isGrade : false,
      isUnit : false
    }
  },
  computed : {
    formattedActualValue() {
      if (this.isTonnage || this.isUnit) {
        return this.$options.filters.toMRMRTonnage(this.actualValue);
      } else if (this.isGrade) {
        return this.$options.filters.toFriendlyGrade(this.actualValue)
      } else  {
        return this.actualValue
      } 
    },
    comparedValue() {
      if (this.previousValue !== null && this.previousValue !== undefined) {
        return this.actualValue - this.previousValue;
      } else {
        return null;
      }
    },
    displayCompare() {
      if (this.comparedValue !== null && (this.comparedValue > 0.01 || this.comparedValue < -0.01)) {
        return true;
      } else {
        return false;
      }
    },
    formattedComparedValue() {
      if (this.comparedValue !== null) {
        if (this.isTonnage || this.isUnit) {
          return this.$options.filters.toMRMRTonnage(this.comparedValue);
        } else if (this.isGrade) {
          return this.$options.filters.toFriendlyGrade(this.comparedValue)
        } else  {
          return this.comparedValue
        } 
      } else {
        return null;
      }
    }
  },
  created() {
    if (this.params.value !== null) {
      this.actualValue = this.params.value.actualValue;
      this.previousValue = this.params.value.previousValue;
      this.isTonnage = this.params.value.isTonnage;
      this.isGrade = this.params.value.isGrade;
      this.isUnit = this.params.value.isUnit;
    }
  }
}
</script>
<style lang="scss">
  .compared {
    font-size: 10px;
    margin-top: -10px;
    padding-right: 30px;
  }
</style>
